<main class="page-main">
	<app-page-sub-nav [data]="pageSubNavData" [currVisible]="currVisible"></app-page-sub-nav>
	<section class="page-section" id="overview">
		<h2 id="sectionTitleOverview" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('overview')">
			Overview <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<app-external-resource [componentName]="'Pagination'" [includeDescription]="true"></app-external-resource>
	</section>
	<section class="page-section" id="example">
		<h2 id="sectionTitleExample" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('example')">
			Live example <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<form class="example-container k-body">
			<div class="page-live-header">
				<select class="page-live-example-select" (change)="changeCurrLive($event)" title="Change example">
					<option value="default">Default</option>
				</select>
				<app-theme-switcher></app-theme-switcher>
			</div>
			<div class="page-live-example-content">
				<div class="page-live-example" [class.page-live-show]="currLive === 'default'">
					<kendo-grid class="sh-data-table" [kendoGridBinding]="pagedData" [sortable]="false" [filterable]="false" [pageable]="false" [style.height]="gridHeight" [scrollable]="'none'">
						<kendo-grid-column
							field="EventTime"
							title="Event Time"
						><ng-template
								kendoGridCellTemplate
								let-dataItem
							>
								{{dataItem.EventTime | date:
								'MM/dd/yyyy&nbsp;&nbsp;hh:mm:ss a'}}
							</ng-template></kendo-grid-column>
						<kendo-grid-column field="EventType" title="Event Type"></kendo-grid-column>
						<kendo-grid-column field="EventAction" title="Event Action"></kendo-grid-column>
						<kendo-grid-column field="ApplicationName" title="Application Name"></kendo-grid-column>
						<kendo-grid-column field="ApplicationType" title="Application Type"></kendo-grid-column>
					</kendo-grid>
					<kendo-datapager
						aria-controls="data-id"
						size="medium"
						type="input"
						[total]="100"
						[pageSize]="pageSize"
						[skip]="skip"
						(pageChange)="onPageChange($event)"
						[pageSizeValues]="[10, 25, 50, 100, 200]">
					</kendo-datapager>
				</div>
			</div>
		</form>
	</section>
	<section class="page-section" id="dev">
		<h2 id="sectionTitleDev" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('dev')">
			Developer resources <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="dev-started">
			<h3 id="subSectionTitleDevStarted" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-started')">
				Getting started <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			Added to your project's app.module.ts file:
			<code style="margin-top: 10px">import &#123; PagerModule &#125; from
				'&#64;progress/kendo-angular-pager';
			</code>
		</section>
		<section class="page-sub-section" id="dev-code">
			<h3 id="subSectionTitleDevCode" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-code')">
				Code examples <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<pre prism class="dark">{{ paginationHTML }}</pre>
		</section>
	</section>
	<section class="page-section" id="styles">
		<h2 id="sectionTitleStyles" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('styles')">
			Styles <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<ul class="page-section-list">
			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">
						Color (light theme)
					</summary>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefault" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Text field</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of textFieldStylesDefault" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Drop-down</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of dropDownStylesDefault" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Icon button</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of iconButtonStylesDefault" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>
			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">
						Color (dark theme)
					</summary>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDark" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Text field</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of textFieldStylesDark" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Drop-down</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of dropDownStylesDark" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Icon button</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of iconButtonStylesDark" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>

			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">Typography</summary>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesTypography" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Text field</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of textFieldStylesTypography" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Drop-down</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of dropDownStylesTypography" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>

			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">Structure</summary>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesStructure" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Text field</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of textFieldStylesStructure" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Drop-down</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of dropDownStylesStructure" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Icon button</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of iconButtonStylesStructure" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>
		</ul>
	</section>

	<section class="page-section" id="behaviors">
		<h2 id="sectionTitleBehaviors" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('behaviors')">
			Behaviors <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="behaviors-disable">
			<h3 id="subSectionTitleBehaviorsDisable" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-disable')">
				Disable <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Pagination controls are disabled while the corresponding component loads.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="behaviors-controls">
			<h3 id="subSectionTitleBehaviorsControls" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-controls')">
				Pagination controls <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Pagination controls are used to navigate pages of data. These controls appear
					to the left-most side of the component.
				</li>
				<li class="page-section-list-item">
					<img class="guidance-image" src="\assets\images\pagination_control_section.png" alt="" />
					<span class="redlines-caption">Example of pagination controls.</span>
				</li>
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">First page</span>
					Navigates the user to the first page of the dataset. This control is disabled
					if a user is already on the first page.
				</li>
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Previous page</span>
					Navigates the user to the previous page in the dataset. Previous always
					meaning 1 lower in the page count, not the last visited page. For example,
					a user on page 5 would be taken to page 4. This control is disabled if the
					user is on the first page.
				</li>
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Text field</span>
					Pagination has a text field where users can input a page number. When the
					user presses the enter key or removes focus from the field, it takes them
					to the page they input.
				</li>
				<li class="page-section-list-item">
					The label around the text field is "Page" and "of Y”. The current page is
					the text field value and the Y is the total number of pages. If there’s no
					data, the text in the pagination control should be “Page 1 of 1”.
				</li>
				<li class="page-section-list-item">
					Only numbers can be entered into the text field. Entering a number above
					the maximum page count automatically lowers it to the number of the last
					page. For example, entering 5 when there are only 4 pages changes the value
					to 4 — the Kendo default. Entering 0 changes the value to 1.
				</li>
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Next page</span>
					Navigates user to the following page in the dataset. For example, if a
					user is on page 5 they would be taken to page 6. This control is disabled
					if the user is already on the last page.
				</li>
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Last page</span>
					Navigates user to the last page in the dataset. This control is disabled
					if the user is already on the last page.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="behaviors-items-per-page">
			<h3 id="subSectionTitleBehaviorsItemsPerPage" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-items-per-page')">
				Items per page drop-down <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<img class="guidance-image" src="\assets\images\pagination_items_per_page.png" alt="" />
					<span class="redlines-caption">Example of spacing around dropdown and items per page text.</span>
				</li>
				<li class="page-section-list-item">
					A drop-down in the middle of the component lets the user select how many
					items to display per page. The options are 10, 25, 50, 100, and 200. 10, or
					the lowest amount, should be the default. This selection should persist
					for the user if the application supports it. The drop-down does not support
					an empty value.
				</li>
				<li class="page-section-list-item">
					The drop-down label should be "X items per page”. The value of X is a
					drop-down with the current selection, followed by “items per page”.
				</li>
				<li class="page-section-list-item">
					The width of the drop-down is smaller than a typical drop-down. They should
					be just wide enough to contain the largest value without cutting off any text.
					Kendo will truncate any text that doesn’t have room.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="behaviors-items-text">
			<h3 id="subSectionTitleBehaviorsItemsText" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-items-text')">
				Showing items text <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Text reading "X-Y of Z items" appears on the right-most side of pagination. X and
					Y is the range of data items that are shown on the current page, and Z is the total
					number of records. As a user pages through the data, the current range automatically
					changes to show where they are in the dataset. For example,  “41-65 of 500 items”.
				</li>
				<li class="page-section-list-item">
					<img class="guidance-image" src="\assets\images\pagination_last_section.png" alt="" />
					<span class="redlines-caption">Example of showing items text.</span>
				</li>
			</ul>
		</section>
	</section>

	<section class="page-section" id="usage">
		<h2 id="sectionTitleUsage" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('usage')">
			Usage guidelines <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="usage-general">
			<h3 id="subSectionTitleUsageGeneral" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-general')">
				General <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Pagination is normally used for data grids and lists. If there is no data
					loaded in the component, pagination is shown but disabled.
				</li>
				<li class="page-section-list-item">
					You can choose to not use pagination for data tables and lists with minimal
					data, but only if you are certain that the dataset will not get any bigger.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="usage-content">
			<h3 id="subSectionTitleUsageContent" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-content')">
				Content <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Labels</span>
					There are 3 labels that make up pagination. A text field label on the left, a drop-down label in the middle, and another label on the right.
				</li>
				<li class="page-section-list-item">
					The text field on the left has the label "Page X of Y”.
				</li>
				<li class="page-section-list-item">
					The drop-down label in the middle is "X items per page”. The value of X is the drop-down, followed by “items per page”.
				</li>
				<li class="page-section-list-item">
					The third label on the right is "X-Y of Z items". If there is no data to be paged through, the label should be “Page 1 of 1”.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="usage-position">
			<h3 id="subSectionTitleUsagePosition" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-position')">
				Position <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Pagination is placed at the bottom of the component it controls. It extends the full width of that component.
				</li>
			</ul>
		</section>
	</section>

	<section class="page-section" id="related">
		<h2 id="sectionTitleRelated" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('related')">
			Related <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<span class="page-related-list-title">Referenced in this section:</span>
		<ul class="page-section-list page-related-list">
			<li class="page-related-list-item">
				<a href="components/button">Button component</a>
			</li>
			<li class="page-related-list-item">
                <a href="guidelines/colors">Colors guidelines</a>
            </li>
			<li class="page-related-list-item">
				<a href="components/drop-down">Drop down component</a>
			</li>
			<li class="page-related-list-item">
				<a href="components/text-field">Text field component</a>
			</li>
			<li class="page-related-list-item">
				<a href="guidelines/typography">Typography guidelines</a>
			</li>
		</ul>

		<span class="page-related-list-title">Components and patterns that use pagination:</span>
		<ul class="page-section-list page-related-list">
			<li class="page-related-list-item">
				<a href="components/data-grid">Data grid component</a>
			</li>
		</ul>
	</section>
	<section class="page-section" id="history">
		<h2 id="sectionTitleHistory" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('history')">
			Revision history <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<ul class="page-history-list">
			<li class="page-history-list-item" *ngFor="
						let subItem of changelogService.getChangelogBySection(
							'Pagination Component'
						)
					">
				<span class="page-history-list-item-title">{{
					changelogService.formatDate(subItem.changeDate)
					}}</span>
				<a class="page-history-list-item-link" target="_blank" *ngIf="subItem.workId != ''" [attr.href]="
							'https://beyondtrust.atlassian.net/jira/software/c/projects/SDS/issues/' +
							subItem.workId
						">[{{ subItem.workId }}]</a>{{ subItem.changeName }}
			</li>
		</ul>
	</section>
</main>
